// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Popconfirm, Radio } from "antd";
import { InfoCircleOutlined, PlusCircleOutlined } from "@ant-design/icons/lib";
import {
  QuestionTemplateDTO,
  SurveyAddBlockButtonProps,
  SurveyWorkflowType
} from "../../../types/SurveyTypes";
import shortid from "shortid";

export const QuestionTypes: QuestionTemplateDTO[] = [
  {
    id: 1,
    name: SurveyWorkflowType.mark
  },
  { id: 2, name: SurveyWorkflowType.simple },
  { id: 3, name: SurveyWorkflowType.multiple },
  { id: 4, name: SurveyWorkflowType.freetext }
];

export const SurveyAddQuestionButton: React.FunctionComponent<SurveyAddBlockButtonProps> = (
  props: SurveyAddBlockButtonProps
) => {
  const { t } = useTranslation();

  const { handleAddQuestion, index, buttonLabel } = props;

  const [questionTemplate, setQuestionTemplate] = useState<
    QuestionTemplateDTO
  >();

  const radioStyle = {
    display: "block",
    height: "40px",
    lineHeight: "40px"
  };

  const initAnswerChoicesFromTemplate = (
    questionTemplate: QuestionTemplateDTO
  ) => {
    if (
      questionTemplate.name === "simple" ||
      questionTemplate.name === "multiple"
    ) {
      return [{ label: "" }];
    }
    if (questionTemplate.name === "mark") {
      return [
        { label: "1" },
        { label: "2" },
        { label: "3" },
        { label: "4" },
        { label: "5" }
      ];
    }
    return [];
  };

  const popconfirmTitle = (
    <>
      <div>
        <strong>{t("survey.global_buttons.question.pop_confirm.title")}</strong>
      </div>
      <div className="my-2">
        <Radio.Group
          buttonStyle="outline"
          onChange={e =>
            setQuestionTemplate(
              QuestionTypes.filter(temp => temp.name === e.target.value)[0]
            )
          }
        >
          {QuestionTypes.map((temp: QuestionTemplateDTO) => (
            <Radio style={radioStyle} key={temp.name} value={temp.name}>
              {t("survey.add_question.type." + temp.name)}
            </Radio>
          ))}
        </Radio.Group>
      </div>
    </>
  );

  return (
    <Popconfirm
      title={popconfirmTitle}
      okText={t("global.confirm")}
      cancelText={t("global.cancel")}
      placement="top"
      icon={<InfoCircleOutlined />}
      onConfirm={() => {
        if (questionTemplate) {
          // Deep copy
          handleAddQuestion(
            {
              id: shortid.generate(),
              type: questionTemplate.name as SurveyWorkflowType,
              templateId: questionTemplate.id,
              label: "",
              answerChoice: initAnswerChoicesFromTemplate(questionTemplate)
            },
            index
          );
        }
      }}
    >
      <Button className="btn-secondary m-2">
        <PlusCircleOutlined /> {buttonLabel}
      </Button>
    </Popconfirm>
  );
};
